import formatMarkdownToHtml from "../../utils/formatMarkdownToHtml";

interface MessageComponentProps {
  message: any;
}

export const MessageComponent = ({ message }: MessageComponentProps) => {
  const formattedMessage = formatMarkdownToHtml(message);
  return <div dangerouslySetInnerHTML={{ __html: formattedMessage }} />;
};
